var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        left: "",
        "min-width": "260",
        "close-on-content-click": false
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "button",
                _vm._g(
                  {
                    staticClass: "topbar-user",
                    attrs: { type: "button", title: "Conta" }
                  },
                  on
                ),
                [
                  _c("ProfessionalAvatar", {
                    attrs: {
                      professional: _vm.currentUser,
                      avatarUrl: _vm.currentUser.avatar_url,
                      size: "36px",
                      textSize: "12px"
                    }
                  })
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menuOpen,
        callback: function($$v) {
          _vm.menuOpen = $$v
        },
        expression: "menuOpen"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tb-user-menu" },
        [
          _c(
            "button",
            {
              staticClass: "tb-user-menu__head",
              attrs: { type: "button" },
              on: { click: _vm.openAvatarUpload }
            },
            [
              _c(
                "span",
                { staticClass: "tb-user-menu__avatar" },
                [
                  _c("ProfessionalAvatar", {
                    attrs: {
                      professional: _vm.currentUser,
                      avatarUrl: _vm.currentUser.avatar_url,
                      size: "46px",
                      textSize: "15px"
                    }
                  }),
                  _c(
                    "span",
                    { staticClass: "tb-user-menu__cam" },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-camera",
                          size: 12,
                          color: "#ffffff"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("span", { staticClass: "tb-user-menu__info" }, [
                _c("span", { staticClass: "tb-user-menu__name" }, [
                  _vm._v(_vm._s(_vm.userName))
                ]),
                _vm.officeName
                  ? _c("span", { staticClass: "tb-user-menu__office" }, [
                      _vm._v(" " + _vm._s(_vm.officeName) + " ")
                    ])
                  : _vm._e(),
                _vm.showAccess
                  ? _c("span", { staticClass: "tb-user-menu__access" }, [
                      _vm._v(" Acesso: "),
                      _c("strong", [_vm._v(_vm._s(_vm.perfilAccess))])
                    ])
                  : _vm._e(),
                _c("span", { staticClass: "tb-user-menu__hint" }, [
                  _vm._v("Trocar foto")
                ])
              ])
            ]
          ),
          _c("v-divider"),
          _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _c(
                "v-list-item",
                { on: { click: _vm.openMeusDados } },
                [
                  _c(
                    "v-list-item-icon",
                    { staticClass: "mr-3" },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "user",
                          size: _vm.ITEM_ICON_SIZE,
                          color: "#5b5b5b"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-list-item-title", [_vm._v("Meus dados")])
                ],
                1
              ),
              _vm.canShowChavesApi
                ? _c(
                    "v-list-item",
                    { on: { click: _vm.openChavesApi } },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "mr-3" },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: "mdi-key-outline",
                              size: _vm.ITEM_ICON_SIZE,
                              color: "#5b5b5b"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-list-item-title", [_vm._v("Chaves de API")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canShowExtensao
                ? _c(
                    "v-list-item",
                    { on: { click: _vm.openExtensaoAawz } },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "mr-3" },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: "mdi-puzzle-outline",
                              size: _vm.ITEM_ICON_SIZE,
                              color: "#5b5b5b"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-list-item-title", [_vm._v("Extensão AAWZ")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canShowWhatsapp
                ? _c(
                    "v-list-item",
                    { on: { click: _vm.openConectarWhatsapp } },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "mr-3" },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: "mdi-whatsapp",
                              size: _vm.ITEM_ICON_SIZE,
                              color: "#5b5b5b"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-list-item-title", [_vm._v("Conectar WhatsApp")])
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-list-item",
                { on: { click: _vm.openSuggest } },
                [
                  _c(
                    "v-list-item-icon",
                    { staticClass: "mr-3" },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-message-text-outline",
                          size: _vm.ITEM_ICON_SIZE,
                          color: "#5b5b5b"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-list-item-title", [
                    _vm._v("Enviar sugestão/dúvida/problema")
                  ])
                ],
                1
              ),
              _c(
                "v-list-item",
                { on: { click: _vm.openAlterarSenha } },
                [
                  _c(
                    "v-list-item-icon",
                    { staticClass: "mr-3" },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-lock-outline",
                          size: _vm.ITEM_ICON_SIZE,
                          color: "#5b5b5b"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-list-item-title", [_vm._v("Alterar senha")])
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-list-item",
                { on: { click: _vm.logout } },
                [
                  _c(
                    "v-list-item-icon",
                    { staticClass: "mr-3" },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-logout",
                          size: _vm.ITEM_ICON_SIZE,
                          color: "#c03939"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-title",
                    { staticClass: "tb-user-menu__logout" },
                    [_vm._v("Sair")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }